var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-item"},[_c('iframe',{attrs:{"src":_vm.videoItem.url,"allowfullscreen":"","width":"560","height":"315","title":"YouTube video player - " + _vm.videoItem.name,"frameborder":"0","allow":"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"}}),_vm._v(" "),(_vm.videoItem.subtitle)?_c('p',[_vm._v("\n    "+_vm._s(_vm.videoItem.subtitle[_vm.$route.params.lang])+"\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53632fa9","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoItem.vue
// module id = 245
// module chunks = 0